export function getStyleHookProps(state, customMapping) {
  let props = {};
  Object.entries(state).forEach(([key, value]) => {
    if (customMapping?.hasOwnProperty(key)) {
      const customProps = customMapping[key](value);
      if (customProps != null) {
        props = {
          ...props,
          ...customProps
        };
      }
      return;
    }
    if (value) {
      props[`data-${key.toLowerCase()}`] = value.toString();
    }
  });
  return props;
}